__turbopack_context__.v({
  "article": "yRL8Va_article",
  "article__meta": "yRL8Va_article__meta",
  "articles": "yRL8Va_articles",
  "header": "yRL8Va_header",
  "list": "yRL8Va_list",
  "viewall": "yRL8Va_viewall",
  "wrapper": "yRL8Va_wrapper",
});
